import styled, { css } from 'styled-components';
import Card from 'components/Card';
import UserAvatar from 'components/UserAvatar';
import { Customer } from 'data/firestore/agent/customer/types';
import { GREY_100 } from '../../../../constants';

export const Container = styled(Card)`
    display: flex;
    padding: 0.75rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.625rem;
    align-self: stretch;
    border-radius: 1rem;
    background: #FFF;
    flex-shrink: 0;
    border: 2px solid ${GREY_100};
    box-shadow: none !important;
`;

export const StyledUserAvatar = styled(UserAvatar)<{ channel?: Customer['channel'] }>`
    border: 4px solid #7367F0;
    svg {
        width: 2.5rem;
        height: 2.5rem;
    }

    ${(props) => props.channel === 'facebook' && css`
        border-color: #1877F2;
    `};
    
    ${(props) => props.channel === 'instagram' && css`
        border-color: #DD2A7B;
    `};

    ${(props) => props.channel === 'whatsapp' && css`
        border-color: #25D366;
    `};
    
    ${(props) => props.channel === 'widget_chatbot' && css`
        border-color: #2E2960;
    `};
`;
